<script lang="ts" setup>
import { computed } from "vue";
import PoolDashboard from "@/features/pool/PoolDashboard.vue";
import KlereoBanner from "@/shared/components/KlereoBanner.vue";
import KlereoIcon from "@/shared/components/KlereoIcon.vue";
import { usePool } from "@/features/pool/usePool.ts";
import PoolConnectionActionIcon from "@/features/pool/header/PoolConnectionActionIcon.vue";
import { useBleDeviceId } from "@/features/ble/utils/useBleDeviceId.ts";
import { useStoredBlePool } from "@/features/ble/utils/localStorage.ts";

const pool = usePool();

const formattedAddress = computed(() => {
  if (!pool.Address) {
    return "";
  } else {
    return (
      pool.Address.street +
      ", " +
      pool.Address.zipcode +
      " " +
      pool.Address.city
    );
  }
});

const bleDeviceId = useBleDeviceId();
const storedBlePool = useStoredBlePool(bleDeviceId);

const displayedName = computed(() => {
  if (bleDeviceId.value) {
    return storedBlePool.value?.localNickname ?? pool.poolNickname;
  }

  return pool.poolNickname;
});
</script>

<template>
  <div>
    <klereo-banner
      @left="$emit('openSidebar')"
      left-icon="klereo"
      left-class="lg:hidden"
      :title="displayedName"
      :description="formattedAddress"
    >
      <template #right-section><PoolConnectionActionIcon /> </template>

      <div class="hidden lg:flex items-center">
        <router-link to="/"
          ><klereo-icon name="house" class="w-[22px]"
        /></router-link></div
    ></klereo-banner>

    <pool-dashboard />
  </div>
</template>
